    <!-- ServicesSlider -->

        $(document).ready(function () {
            $("#ServiceSlider").owlCarousel({
                loop: true,
                margin: 5,
                dots: false,
                items: 3,
                nav: false,
                responsiveClass: true,
                autoplay: true,
                slideTransition: 'ease-in-out',
                // smartSpeed: 1500,
                responsive: {
                    0: {
                        items: 1,
                        nav: false,
                    },
                    768: {
                        items: 3,
                        nav: false,
                    },
                    1024: {
                        items: 5,
                        nav: false,
                    },
                    1200: {
                        items: 5,
                        nav: false,
                    },
                },
            });
        });

 <!-- ProductSlider -->

        $(document).ready(function () {
            $("#ProductSlider").owlCarousel({
                loop: true,
                margin: 24,
                dots: false,
                items: 3,
                nav: true,
                responsiveClass: true,
                autoplay: true,
                slideTransition: 'ease-in-out',
                // smartSpeed: 1500,
                responsive: {
                    0: {
                        items: 1,
                        nav: true,
                    },
                    768: {
                        items: 2,
                        nav: true,
                    },
                    1024: {
                        items: 2,
                        nav: true,
                    },
                    1200: {
                        items: 2,
                        nav: true,
                    },
                },
            });
        });

 <!-- ProductSlider -->

        $(document).ready(function () {
            $("#Product1Slider").owlCarousel({
                loop: true,
                margin: 24,
                dots: false,
                items: 3,
                nav: true,
                responsiveClass: true,
                autoplay: true,
                slideTransition: 'ease-in-out',
                // smartSpeed: 1500,
                responsive: {
                    0: {
                        items: 1,
                       nav: true,
                    },
                    768: {
                        items: 2,
                          nav: true,
                    },
                    1024: {
                        items: 2,
                          nav: true,
                    },
                    1200: {
                        items: 2,
                        nav: true,
                    },
                },
            });
        });


 